// extracted by mini-css-extract-plugin
export default {"postPreview":"Preview_postPreview__nPo8X","postPreviewInner":"Preview_postPreviewInner__6dz1p"};